<ziro-self-serve-top-bar></ziro-self-serve-top-bar>

<ziro-loading-block [hidden]="!isLoading"></ziro-loading-block>

<div [hidden]="isLoading">
  <ziro-self-serve-user-details-back
    [link]="'/self-serve/user/' + user?.ref.username"
  ></ziro-self-serve-user-details-back>

  <ziro-self-serve-user-details-header
    [heading]="'tkey;self_serve.call_forward.header' | translate"
    [headingDataAutomation]="'self-server-user-details-call-forward-header'"
  ></ziro-self-serve-user-details-header>

  <ziro-text [fieldId]="'callForward'"></ziro-text>

  <div class="col-sm-12 text-end">
    <ziro-submit-button
      [isPending]="isSubmitting"
      [isDisabled]="isSubmitting"
      [cssClass]="'me-2'"
      [dataAutomation]="'self-serve-call-forward-edit-submit-button'"
      [label]="'tkey;selfserve.user.call_forward.button.label'"
      [buttonStyle]="buttonStyles.OUTLINE_PRIMARY"
      [iconPending]="ziroIcons.SAVING"
      [formSubmitSubject]="_validateAndSubmitSource"
    ></ziro-submit-button>
  </div>
</div>
